

export interface IProductConfiguration {
	readonly quality?: string;
}
